<div class='wrapper' [formGroup]='commentsGroup'>
  <div class='head' fxLayout fxLayoutAlign='space-between center' fxLayoutGap='12px'>
    <div fxLayout='column' fxLayoutGap='4px'>
      <span class='manager'>{{ data.managerName }}</span>
      <span>{{ data.metricGroup }}</span>
    </div>

    <mat-icon (click)='closeDialog()'>close</mat-icon>
  </div>

  <div class='content' formArrayName='comments'>
    <div *ngFor='let reason of data.reasonSet; let i = index' class='reason-card' fxLayout='column'>
      <div class='client-candidate' fxLayout fxLayoutAlign='space-between'>
        <div fxFlex='45'>
          {{ 'CANDIDATE' | translate }}: <span>
          <ng-container *ngFor='let candidate of candidatesDict[reason.id]; let i = index'>
            <div class="candidate-item">
              <a
                *ngIf="candidate.employeeLivasId"
                href="{{ regionService.configureBaseUrlByRegion(candidate.country?.isoCode || 'lt') }}personalas.php?id={{ candidate.employeeLivasId }}"
                target='_blank'
              >
                <mat-icon svgIcon="engineering"></mat-icon>
              </a>

              <mat-icon *ngIf="!candidate.employeeLivasId" svgIcon="engineering" [style.color]="'gray'"></mat-icon>

              <ng-container *ngIf="candidate.livasId; else candidateNoLink">
                <a
                  href="{{ regionService.configureBaseUrlByRegion(candidate.country?.isoCode || 'lt') }}interviu.php?id={{ candidate.livasId }}"
                  target='_blank'
                >
                  {{ candidate.firstName }} {{ candidate.lastName }}
                </a>
                <span *ngIf='i < (candidatesDict[reason.id]?.length - 1)'>, </span>
              </ng-container>

              <ng-template #candidateNoLink>
                <span>{{ candidate.firstName }} {{ candidate.lastName }}</span>
                <span *ngIf='i < (candidatesDict[reason.id]?.length - 1)'>, </span>
              </ng-template>
            </div>
          </ng-container>

          <ng-container *ngIf='!candidatesDict[reason.id]'>---</ng-container>
        </span>
        </div>

        <div fxFlex='45'>
          {{ 'CLIENT.CLIENT' | translate }}: <span>
            <ng-container *ngFor='let client of clientsDict[reason.id]; let i = index'>
              <ng-container *ngIf="client.id; else candidateNoLink">
                <a href="{{ regionService.configureBaseUrlByRegion(client.country?.isoCode || 'lt') }}klientai.php?id={{ client.livasId }}"
                   target='_blank'>
                  {{ client.name }}
                </a>
                <span *ngIf='i < (clientsDict[reason.id]?.length - 1)'>, </span>
              </ng-container>

              <ng-template #candidateNoLink>
                <span>{{ client.name }}</span>
                <span *ngIf='i < (clientsDict[reason.id]?.length - 1)'>, </span>
              </ng-template>
            </ng-container>

            <ng-container *ngIf='!clientsDict[reason.id]'>---</ng-container>
          </span>
        </div>
      </div>

      <div class='reason' [class.active]="isReasonChangeAllowed">
        {{ 'REASON_TITLE' | translate }}: <span [matMenuTriggerFor]='isReasonChangeAllowed ? editMenu : undefined'>
          {{ reasonsTitlesDict[reason.id] || '---' }} <mat-icon *ngIf="isReasonChangeAllowed">keyboard_arrow_down</mat-icon>
        </span>
      </div>

      <mat-form-field appearance="outline" class="new-comment">
        <textarea matInput cdkTextareaAutosize [formControlName]='i' [placeholder]="'NEW_COMMENT' | translate"></textarea>
      </mat-form-field>

      <div fxLayout fxLayoutGap="16px" fxLayoutAlign="end center">
        <button
          *ngIf="candidatesDict[reason.id]?.length"
          mat-flat-button
          color="primary"
          (click)='openCandidatesDialog(reason.id)'
        >
          {{ "SHOW_CANDIDATE" | translate }}
        </button>

        <button
          mat-flat-button
          color="primary"
          [disabled]='(comments.at(i)?.value === reason.comment && reasons.at(i)?.value === reason.metricClientReason?.id) || isSaving'
          (click)='saveComment(reason, comments.at(i)?.value, reasons.at(i)?.value)'
        >
          {{ "COMMON.SAVE" | translate }}
        </button>
      </div>

      <mat-menu #editMenu='matMenu'>
        <div mat-menu-item (click)="reasons.at(i)?.setValue(null); reasonsTitlesDict[reason.id] = null">
          -- No reason --
        </div>

        <div
          *ngFor="let rs of metricClientReasons"
          mat-menu-item
          (click)="reasons.at(i)?.setValue(rs.id); reasonsTitlesDict[reason.id] = rs.title"
        >{{ rs.title }}</div>
      </mat-menu>
    </div>
  </div>
</div>
